import { useMemo } from 'react';
import { Client, useProjects } from './useProjects';
import { useClientId } from './useClientId';
import { allClients } from '../components/ClientBuildingSelector/allClientsInjection';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDefaultData } from '@/hooks/useDefaultData';
import { constructLink } from '@/utils/functions';

export const queryKeyClient = 'client';
export const queryKeyRecordId = 'recordId';
const isMOE = () => {
  const location = window.location;
  return location.pathname.includes('/moe');
};
export function useClientData(): Client | undefined {
  const [clientId] = useClientId();
  const isMoe = isMOE();
  const navigate = useNavigate();
  const location = useLocation();
  const { data: defaultData } = useDefaultData();
  const projects = useProjects(data => {
    const isAllClients = data.data?.some(project => project.id === 'all');

    if (isMoe && !isAllClients) {
      // Add allClients if MOE route and not already present
      data.data?.unshift(allClients);
    } else if (!isMoe && isAllClients) {
      // Remove allClients if not MOE route and it exists
      data.data = data.data?.filter(project => project.id !== 'all') ?? null;
      navigate(constructLink(location.pathname, defaultData?.defaultClient));
    }

    return data;
  });

  const client = useMemo(() => {
    if (!clientId) return undefined;

    return projects.data?.data?.find(project => project.id === clientId);
  }, [clientId, projects.data]);

  return client;
}
